module.exports = __webpack_public_path__ + "static/media/Style3.595cf8b7.PNG";